const baseFontSize: 16 = 16;

export const getRemValue = (fontSize: number): string => `${fontSize / baseFontSize}rem`;
